import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import type { ErgebnisInput } from '../../interfaces/ergebnis-input.model';

/** The card around a result; what goes left, right and below is projected by the caller. */
@Component({
  selector: 'ui-results-item',
  templateUrl: './results-item.component.html',
  styleUrl: './results-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultsItemComponent {
  readonly icon = input<string>();
  readonly ergebnis = input.required<ErgebnisInput>();
}
